module.exports = __webpack_public_path__ + "fonts/Inter-500-greek53.eb1153e.woff2";